import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { Firebase, Game } from '../../../Core'

import * as actions from '../ranking.actions'
import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import FederationFlag from '../../Components/FederationFlag'

/**
 *  Main ranking view
 */
class Federations extends React.Component {
  /****/
  constructor(props) {
    super(props)
    this.state = {}
  }

  selectFederation(federation) {
    const { selectFederation, addScreen } = this.props

    selectFederation(federation)
    addScreen('federation_ranking')
  }

  displayButton(icon, action) {
    const { addHowlSound } = this.props

    return (
      <span
        className={icon}
        onClick={() => {
          action()
          addHowlSound('button_click_icon')
        }}
      ></span>
    )
  }

  renderFederationInfo(federation) {
    const { addPopup, setChatTarget, currentUser } = this.props
    const activeClass = federation.id == currentUser.federation.id ? 'active' : ''
    let fixedPoints =
      isNaN(federation.points) || federation.points == undefined ? 0 : federation.points.toFixed(2)
    return (
      <div key={federation.id} className={`mis--item  ${activeClass}`}>
        <div className="mis--item__info">
          <span className="position">{federation.position}</span>
          <div className="icons">
            {currentUser.federation.id === federation.id
              ? this.displayButton('icon-send', () => {
                  addPopup('chat_popup')
                  setChatTarget({ type: 'federation', id: federation.name })
                })
              : null}
            <span onClick={() => this.selectFederation(federation)} className="icon-faqs"></span>
          </div>
        </div>
        <div className="mis--item__info">
          <FederationFlag flag={federation.flag} />
          <div className="identity">
            <span className="text username">{federation.name}</span>
            <span className="num">
              <span className="icon-settlers"> </span> {fixedPoints}{' '}
            </span>
          </div>
        </div>
      </div>
    )
  }

  /**
   *  Render component
   */
  render() {
    const { federationRanking } = this.props
    return federationRanking.map((federation) => this.renderFederationInfo(federation))
  }
}

const mapStateToProps = (state) => ({
  federationRanking: Firebase.selectors.getFederationsRanking(state),
  currentUser: tutorialSelectors.isTutorialMode(state)
    ? tutorialSelectors.getCurrentUser(state)
    : Firebase.selectors.getUserData(state),
})

const mapDispatchToProps = (dispatch) => ({
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  selectFederation: bindActionCreators(actions.selectFederation, dispatch),
  setChatTarget: bindActionCreators(actions.setChatTarget, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

Federations.propTypes = {
  federationRanking: PropTypes.array,
  selectFederation: PropTypes.func,
  addScreen: PropTypes.func,
  addPopup: PropTypes.func,
  setChatTarget: PropTypes.func,
  addHowlSound: PropTypes.func,
  currentUser: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Federations))
